module.exports = __webpack_public_path__ + "static/media/zoho.334d8d53.png";